<template>
  <div class="body-wrap">
    <!-- 搜索 -->
    <div class="search-wrap" >
      <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
      <el-button size="mini" type="primary" @click="getList(1)" :loading="searchLoading">搜索</el-button>
      <div class="opt-wrap">
        <el-button size="mini" type="primary" @click="openSaveDialog()" icon="el-icon-plus">添加模版分类</el-button>
      </div>
    </div>

    <!-- 数据列表 -->
    <div class="table-wrap" >
      <el-table border v-loading="searchLoading" :data="tableData" default-expand-all
                row-key="id"
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      >
        <el-table-column prop="name" label="分类名称" align="center"></el-table-column>
        <el-table-column prop="sort_order" label="排序权重" align="center"></el-table-column>
        <el-table-column prop="description" label="分类描述" align="center"></el-table-column>
        <el-table-column prop="created_at" label="创建日期" align="center"></el-table-column>
        <el-table-column prop="updated_at" label="修改日期" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="openSaveDialog(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <SaveView ref="saveRef" @close="getList"/>
  </div>
</template>

<script>
import SaveView from './save.vue'
export default {
  components: { SaveView },
  name: "ProjectCollectionTemplateCategory",
  data(){
    return{
      keyword: '',
      searchLoading:  false,
      page: 1,
      pageSize: 20,
      tableData: [],
    }
  },
  mounted() {
    this.getList()
  },
  methods:{
    getList(p) {
      if(p)this.page = p
      this.$myhttp.get('butler/ProjectCollectionTemplateCategory/getList', {params: {page: this.page, page_size: this.pageSize, keyword: this.keyword}}).then(resp => {
        let res = resp.data
        if(res.code == 1) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
      })
    },
    del(row) {
      this.$alert('确认删除' + row.name + '模版分类?', '删除确认', {
        confirmButtonText: '确定',
        callback: action => {
          if(action == 'confirm') {
            this.$myhttp.get('butler/ProjectCollectionTemplateCategory/delete', {params: {id: row.id}}).then(resp => {
              let res = resp.data
              if(res.code == 1) {
                this.$message({
                  type: 'success',
                  message: res.msg
                });
                this.getList()
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                });
              }
            })
          }
        }
      });
    },
    openSaveDialog(data) {
      this.$refs.saveRef.show(data)
    }
  }
}
</script>

<style lang="scss" scoped>

@import '../../common.scss';

.body-wrap {
  padding: 10px;
}

.search-wrap {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/projectCollectionTemplate/category/index.vue